import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BootstrapThemeProp } from '@app/core/services/bootstrap-theme.service';
import { Modal } from '@app/modules/modals/modals.module';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'fdx-exports-simulated-date-time-modal',
    templateUrl: './exports-simulated-date-time-modal.component.html',
    styleUrl: './exports-simulated-date-time-modal.component.scss',
    standalone: false
})
export class ExportsSimulatedDateTimeModalComponent implements Modal {
    public modalTheme: BootstrapThemeProp = 'secondary';

    // eslint-disable-next-line @typescript-eslint/typedef
    public simulatedDateTimeForm = new FormGroup({
        simulatedDate: new FormControl('', Validators.required)
    });

    constructor(
        private readonly modal: NgbActiveModal
    ) { }

    public onModalSubmit(_event: MouseEvent): void {
        if (this.simulatedDateTimeForm.invalid) {
            this.simulatedDateTimeForm.markAllAsTouched();
            return;
        }
        this.modal.close(this.simulatedDateTimeForm.value.simulatedDate);
    }

    public onModalCancel(_event: MouseEvent): void {
        this.modal.dismiss();
    }
}
